import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-campaign-ssg" }

import { IProgram } from '@/types/program';
import Banner from './components/banner.vue';
import Navbar from './components/navbar.vue';
import Page1 from './components/page-1.vue';
import Page2 from './components/page-2/index.vue';
import Page3 from './components/page-3.vue';
import Page4 from './components/page-4.vue';
import Page5 from './components/page-5.vue';
import Page6 from './components/page-6.vue';
import Page7 from './components/page-7.vue';
import { provide } from 'vue';

export interface IProps {
  program: IProgram;
  collectionStartedAt?: string;
  collectionEndedAt?: string;
  participateEndedAt?: string;
  announcementAt?: string;
}
export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) },
    collectionStartedAt: { default: '2023-06-22T15:00:00.000Z' },
    collectionEndedAt: { default: '2023-08-23T14:59:59.000Z' },
    participateEndedAt: { default: '2023-06-19T14:59:59.000Z' },
    announcementAt: { default: '2023-06-20T15:00:00.000Z' }
  },
  setup(__props: any) {

const props = __props as { program: IProgram, collectionStartedAt: string, collectionEndedAt: string, participateEndedAt: string, announcementAt: string }

;



provide('collection_started_at', props.collectionStartedAt);
provide('collection_ended_at', props.collectionEndedAt);
provide('participate_ended_at', props.participateEndedAt);
provide('announcement_at', props.announcementAt);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner),
    _createVNode(Navbar, { program: __props.program }, null, 8, ["program"]),
    _createVNode(Page1),
    _createVNode(Page2),
    _createVNode(Page3),
    _createVNode(Page4),
    _createVNode(Page5),
    _createVNode(Page6, { program: __props.program }, null, 8, ["program"]),
    _createVNode(Page7)
  ]))
}
}

})